// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  -webkit-text-size-adjust: 100%;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  height: 100%;
}

body {
  margin: 0;
  background: #f7fbfc;
}

.appbar_container {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1300;
  background: #ffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, .08);
}


.dashboard-top-bar {
  position: fixed !important;
  top: var(--nav-h) !important;
  left: 0;
  right: 0;
  z-index: 1250;
  box-shadow: 0 10px 20px #0000004d !important;
}

.app-main {
  min-height: 100dvh;
  min-height: -webkit-fill-available;
  width: 100%;
  max-width: 100%;
  width: stretch;
  width: -webkit-fill-available;
  overflow: auto;
  padding-top: var(--chrome-h);
  padding-left: 8px;
  padding-right: 8px;
  background: #f7f9fc;
}

.table_container {
  top: auto !important;
}

.card-header {
  position: sticky;
  top: 0;
  z-index: 2;
}

.data-table-container {
  height: calc(100dvh - var(--chrome-h) - 32px);
  height: calc(-webkit-fill-available - var(--chrome-h) - 32px);
  overflow: auto;
}

.data-table-head-row,
.data-table-head .MuiTableCell-head {
  position: sticky;
  top: 0;
  z-index: 3;
}


.MuiPopover-root,
.MuiPopover-root .MuiPaper-root,
.litepicker {
  z-index: 1500 !important;
}


@media (max-width: 600px) {
  :root {
    --nav-h: 48px;
    --tabs-h: 36px;
  }
}

@media (min-width:0px) {
  div.table_container {
    top: auto !important;
  }
}


.nav-logo {
  height: 32px;
  max-height: 32px;
  width: auto;
  max-width: 120px;
  margin-left: 8px;
  margin-right: 8px;
  object-fit: contain;
  animation: fadeIn 0.5s ease-in-out;
}

.operations-3d-title {
  font-family: Roboto, Arial, sans-serif !important;
  color: #0C66E4 !important;
  font-weight: bold !important;
  font-size: 20px !important;
  margin-left: 1rem;
}

.initial-circle {
  color: #384988 !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
  margin-right: 10px;
  cursor: pointer;
}

.css-53g0n7-MuiButtonBase-root-MuiIconButton-root:hover {
  background: none !important;
}

.avatar {
  background-color: #384988 !important;
  color: white;
  font-weight: bold;
  border-radius: 50% !important;
  width: 40px !important;
  height: 40px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px !important;
  margin-left: 10px;
  cursor: pointer;
  box-shadow: none !important;
  font: var(--ds-font-body, bold 16px / 1.42857142857143 -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif) !important;
}

.user-name {
  margin-bottom: 10px !important;
  color: #2f4f4f !important;
  font-family: Roboto, Arial, sans-serif !important;
  font-size: 17.5px !important;
  line-height: 1.5 !important;
  letter-spacing: 0.0075em !important;
  font-weight: 700 !important;
}

.user-email {
  font: var(--ds-font-body, 14px / 1.42857142857143 -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif) !important;
  color: #00000099;
  margin-bottom: 20px !important;
}

.btn-grp {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  gap: 10px;
}


.css-b7dj7n-MuiList-root {
  list-style: none;
  position: relative;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.dashboard-toolbar {
  display: flex;
  justify-content: flex-start;
  background-color: #4285f4 !important;
  box-shadow: 0 10px 20px #0000004d !important;
}

.top-bar-list {
  display: inline-flex;
}

.top-bar-list .MuiListItem-root {
  width: auto;
}

.top-bar-list .MuiListItemButton-root {
  width: auto;
  min-width: 0;
  flex: 0 0 auto;
}

@media (max-width: 768px) {
  .nav-logo {
    height: 28px;
    max-height: 28px;
    max-width: 100px;
  }
}

@media (max-width: 480px) {
  .nav-logo {
    height: 24px;
    max-height: 24px;
    max-width: 80px;
  }
}

.theme-blue {
  --primary-color: rgb(14, 114, 237);
  --primary-hover: rgb(12, 102, 213);
  --primary-gradient: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  --primary-gradient-hover: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  --toggle-shadow: 59, 130, 246;
  --background-gradient: linear-gradient(135deg, #e9edf5 0%, #adcaed 100%);
  --border-radius: 12px;
  --border-radius-small: 8px;
  --shadow-light: 0 2px 8px rgba(0, 0, 0, .1);
  --shadow-medium: 0 4px 16px rgba(0, 0, 0, .12);
  --shadow-heavy: 0 8px 32px rgba(0, 0, 0, .15);
  --transition: all .3s ease;
  --ink: #1a202c;
}

.responsive-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 45px;
  box-sizing: border-box;
}

.responsive-item {
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  box-shadow: var(--shadow-medium);
  border: 1px solid rgba(255, 255, 255, .2);
  backdrop-filter: blur(10px);
  transition: var(--transition);
  min-height: calc(98vh - 30px);
}

.responsive-item:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-heavy);
}

.responsive-fields {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 28px;
}

.field-block {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 20px !important;
}

.field-block .mui-like-field {
  width: 100%;
}

.select-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.select-card {
  width: 100%;
}


.forms {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  width: 100%;
}

.headings {
  font-weight: 600 !important;
  color: #1a202c !important;
  font-size: 16px !important;
  line-height: 1.5 !important;
  letter-spacing: .3px !important;
  margin-bottom: 5px !important;
}

.required-asterisk {
  color: red;
  font-size: 20px;
}

.btns-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 32px;
}

.reset-btn {
  background: linear-gradient(135deg, #d97706 0%, #d97706 100%) !important;
  color: #fff !important;
  border: none !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
}

.reset-btn:hover {
  background: linear-gradient(135deg, #d97706 0%, #d97706 100%) !important;
  box-shadow: 0 8px 25px rgba(249, 115, 22, 0.4) !important;
  transform: translateY(-2px);
}

.btn-base {
  font-size: 14px;
  font-weight: 500;
  padding: 20px 25px !important;
  border-radius: var(--border-radius-small) !important;
  border: none;
  cursor: pointer;
  transition: var(--transition);
  text-transform: none;
  min-width: 120px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--shadow-light);
}

.btn-base:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-medium);
}

.normal-btn {
  background: var(--primary-gradient) !important;
  color: #fff !important;
}

.normal-btn:hover {
  background: var(--primary-gradient-hover) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 25px hsla(var(--toggle-shadow), .4) !important;
}

.mui-like-field {
  position: relative;
}

.mui-like-input {
  width: 100%;
  border-radius: var(--border-radius);
  border: 1px solid rgba(0, 0, 0, .23);
  background: #fff;
  padding: 12px 14px;
  font-size: 16px;
  color: var(--ink);
  transition: border-color .2s ease, box-shadow .2s ease, border-width .2s ease;
  outline: none;
  min-height: 56px;
  box-sizing: border-box;
  appearance: none;
}

.mui-like-input:hover {
  border-color: rgba(0, 0, 0, .23);
  box-shadow: none;
}

.mui-like-input:focus {
  border-color: var(--primary-hover) !important;
  border-width: 2px;
  box-shadow: none;
}

.mui-like-input::placeholder {
  color: #9ca3af;
}

select.mui-like-input {
  background-image:
    linear-gradient(45deg, transparent 50%, #6b7280 50%),
    linear-gradient(135deg, #6b7280 50%, transparent 50%),
    linear-gradient(to right, transparent, transparent);
  background-position:
    calc(100% - 22px) calc(1.05em + 4px),
    calc(100% - 16px) calc(1.05em + 4px),
    100% 0;
  background-size: 6px 6px, 6px 6px, 2.5em 2.5em;
  background-repeat: no-repeat;
  padding-right: 48px;
}

.select-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
}

.select-card {
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 16px;
  cursor: pointer;
  background: #fff;
  box-shadow: var(--shadow-light);
  transition: var(--transition);
  user-select: none;
}

.select-card:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-medium);
}

.select-card input {
  width: 18px;
  height: 18px;
  accent-color: rgb(14, 114, 237);
  margin: 0;
}

.select-card.active {
  border-color: var(--primary-hover);
  box-shadow: 0 0 0 3px hsla(var(--toggle-shadow), .12);
}

.select-card-label {
  font-weight: 600;
  color: #374151;
}

.section {
  display: none;
}

.section.active {
  display: block;
}

@media (max-width: 768px) {
  .responsive-item {
    padding: 20px;
    border-radius: var(--border-radius);
  }

  .responsive-fields {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .btn-base {
    min-width: 100px;
    height: 40px;
    font-size: 13px;
    padding: 8px 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/style.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,yCAAyC;AAC3C;;;AAGA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,OAAO;EACP,QAAQ;EACR,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,cAAc;EACd,6BAA6B;EAC7B,cAAc;EACd,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;;AAGA;;;EAGE,wBAAwB;AAC1B;;;AAGA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;;AAGA;EACE,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,uMAAuM;AACzM;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,iDAAiD;EACjD,4BAA4B;EAC5B,2BAA2B;EAC3B,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,kMAAkM;EAClM,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,qEAAqE;EACrE,2EAA2E;EAC3E,6BAA6B;EAC7B,wEAAwE;EACxE,qBAAqB;EACrB,0BAA0B;EAC1B,2CAA2C;EAC3C,8CAA8C;EAC9C,6CAA6C;EAC7C,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,yCAAyC;EACzC,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wEAAwE;EACxE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,wEAAwE;EACxE,yDAAyD;EACzD,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,oDAAoD;EACpD,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,oDAAoD;EACpD,sCAAsC;EACtC,gEAAgE;AAClE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6EAA6E;EAC7E,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;;uDAGqD;EACrD;;;UAGQ;EACR,8CAA8C;EAC9C,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;IACb,mCAAmC;EACrC;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["html {\n  -webkit-text-size-adjust: 100%;\n}\n\nbody {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n#root {\n  height: 100%;\n}\n\nbody {\n  margin: 0;\n  background: #f7fbfc;\n}\n\n.appbar_container {\n  position: fixed !important;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 1300;\n  background: #ffff;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, .08);\n}\n\n\n.dashboard-top-bar {\n  position: fixed !important;\n  top: var(--nav-h) !important;\n  left: 0;\n  right: 0;\n  z-index: 1250;\n  box-shadow: 0 10px 20px #0000004d !important;\n}\n\n.app-main {\n  min-height: 100dvh;\n  min-height: -webkit-fill-available;\n  width: 100%;\n  max-width: 100%;\n  width: stretch;\n  width: -webkit-fill-available;\n  overflow: auto;\n  padding-top: var(--chrome-h);\n  padding-left: 8px;\n  padding-right: 8px;\n  background: #f7f9fc;\n}\n\n.table_container {\n  top: auto !important;\n}\n\n.card-header {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.data-table-container {\n  height: calc(100dvh - var(--chrome-h) - 32px);\n  height: calc(-webkit-fill-available - var(--chrome-h) - 32px);\n  overflow: auto;\n}\n\n.data-table-head-row,\n.data-table-head .MuiTableCell-head {\n  position: sticky;\n  top: 0;\n  z-index: 3;\n}\n\n\n.MuiPopover-root,\n.MuiPopover-root .MuiPaper-root,\n.litepicker {\n  z-index: 1500 !important;\n}\n\n\n@media (max-width: 600px) {\n  :root {\n    --nav-h: 48px;\n    --tabs-h: 36px;\n  }\n}\n\n@media (min-width:0px) {\n  div.table_container {\n    top: auto !important;\n  }\n}\n\n\n.nav-logo {\n  height: 32px;\n  max-height: 32px;\n  width: auto;\n  max-width: 120px;\n  margin-left: 8px;\n  margin-right: 8px;\n  object-fit: contain;\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n.operations-3d-title {\n  font-family: Roboto, Arial, sans-serif !important;\n  color: #0C66E4 !important;\n  font-weight: bold !important;\n  font-size: 20px !important;\n  margin-left: 1rem;\n}\n\n.initial-circle {\n  color: #384988 !important;\n  width: 40px !important;\n  height: 40px !important;\n  border-radius: 50% !important;\n  margin-right: 10px;\n  cursor: pointer;\n}\n\n.css-53g0n7-MuiButtonBase-root-MuiIconButton-root:hover {\n  background: none !important;\n}\n\n.avatar {\n  background-color: #384988 !important;\n  color: white;\n  font-weight: bold;\n  border-radius: 50% !important;\n  width: 40px !important;\n  height: 40px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px !important;\n  margin-left: 10px;\n  cursor: pointer;\n  box-shadow: none !important;\n  font: var(--ds-font-body, bold 16px / 1.42857142857143 -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif) !important;\n}\n\n.user-name {\n  margin-bottom: 10px !important;\n  color: #2f4f4f !important;\n  font-family: Roboto, Arial, sans-serif !important;\n  font-size: 17.5px !important;\n  line-height: 1.5 !important;\n  letter-spacing: 0.0075em !important;\n  font-weight: 700 !important;\n}\n\n.user-email {\n  font: var(--ds-font-body, 14px / 1.42857142857143 -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif) !important;\n  color: #00000099;\n  margin-bottom: 20px !important;\n}\n\n.btn-grp {\n  margin-top: 10px;\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n\n.css-b7dj7n-MuiList-root {\n  list-style: none;\n  position: relative;\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n\n.dashboard-toolbar {\n  display: flex;\n  justify-content: flex-start;\n  background-color: #4285f4 !important;\n  box-shadow: 0 10px 20px #0000004d !important;\n}\n\n.top-bar-list {\n  display: inline-flex;\n}\n\n.top-bar-list .MuiListItem-root {\n  width: auto;\n}\n\n.top-bar-list .MuiListItemButton-root {\n  width: auto;\n  min-width: 0;\n  flex: 0 0 auto;\n}\n\n@media (max-width: 768px) {\n  .nav-logo {\n    height: 28px;\n    max-height: 28px;\n    max-width: 100px;\n  }\n}\n\n@media (max-width: 480px) {\n  .nav-logo {\n    height: 24px;\n    max-height: 24px;\n    max-width: 80px;\n  }\n}\n\n.theme-blue {\n  --primary-color: rgb(14, 114, 237);\n  --primary-hover: rgb(12, 102, 213);\n  --primary-gradient: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);\n  --primary-gradient-hover: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  --toggle-shadow: 59, 130, 246;\n  --background-gradient: linear-gradient(135deg, #e9edf5 0%, #adcaed 100%);\n  --border-radius: 12px;\n  --border-radius-small: 8px;\n  --shadow-light: 0 2px 8px rgba(0, 0, 0, .1);\n  --shadow-medium: 0 4px 16px rgba(0, 0, 0, .12);\n  --shadow-heavy: 0 8px 32px rgba(0, 0, 0, .15);\n  --transition: all .3s ease;\n  --ink: #1a202c;\n}\n\n.responsive-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 45px;\n  box-sizing: border-box;\n}\n\n.responsive-item {\n  background: #fff;\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: var(--shadow-medium);\n  border: 1px solid rgba(255, 255, 255, .2);\n  backdrop-filter: blur(10px);\n  transition: var(--transition);\n  min-height: calc(98vh - 30px);\n}\n\n.responsive-item:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-heavy);\n}\n\n.responsive-fields {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-bottom: 28px;\n}\n\n.field-block {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin-top: 20px !important;\n}\n\n.field-block .mui-like-field {\n  width: 100%;\n}\n\n.select-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.select-card {\n  width: 100%;\n}\n\n\n.forms {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-width: 0;\n  width: 100%;\n}\n\n.headings {\n  font-weight: 600 !important;\n  color: #1a202c !important;\n  font-size: 16px !important;\n  line-height: 1.5 !important;\n  letter-spacing: .3px !important;\n  margin-bottom: 5px !important;\n}\n\n.required-asterisk {\n  color: red;\n  font-size: 20px;\n}\n\n.btns-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  margin-top: 32px;\n}\n\n.reset-btn {\n  background: linear-gradient(135deg, #d97706 0%, #d97706 100%) !important;\n  color: #fff !important;\n  border: none !important;\n  font-weight: 600 !important;\n  text-transform: none !important;\n  transition: all 0.3s ease !important;\n}\n\n.reset-btn:hover {\n  background: linear-gradient(135deg, #d97706 0%, #d97706 100%) !important;\n  box-shadow: 0 8px 25px rgba(249, 115, 22, 0.4) !important;\n  transform: translateY(-2px);\n}\n\n.btn-base {\n  font-size: 14px;\n  font-weight: 500;\n  padding: 20px 25px !important;\n  border-radius: var(--border-radius-small) !important;\n  border: none;\n  cursor: pointer;\n  transition: var(--transition);\n  text-transform: none;\n  min-width: 120px;\n  height: 44px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: var(--shadow-light);\n}\n\n.btn-base:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-medium);\n}\n\n.normal-btn {\n  background: var(--primary-gradient) !important;\n  color: #fff !important;\n}\n\n.normal-btn:hover {\n  background: var(--primary-gradient-hover) !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 8px 25px hsla(var(--toggle-shadow), .4) !important;\n}\n\n.mui-like-field {\n  position: relative;\n}\n\n.mui-like-input {\n  width: 100%;\n  border-radius: var(--border-radius);\n  border: 1px solid rgba(0, 0, 0, .23);\n  background: #fff;\n  padding: 12px 14px;\n  font-size: 16px;\n  color: var(--ink);\n  transition: border-color .2s ease, box-shadow .2s ease, border-width .2s ease;\n  outline: none;\n  min-height: 56px;\n  box-sizing: border-box;\n  appearance: none;\n}\n\n.mui-like-input:hover {\n  border-color: rgba(0, 0, 0, .23);\n  box-shadow: none;\n}\n\n.mui-like-input:focus {\n  border-color: var(--primary-hover) !important;\n  border-width: 2px;\n  box-shadow: none;\n}\n\n.mui-like-input::placeholder {\n  color: #9ca3af;\n}\n\nselect.mui-like-input {\n  background-image:\n    linear-gradient(45deg, transparent 50%, #6b7280 50%),\n    linear-gradient(135deg, #6b7280 50%, transparent 50%),\n    linear-gradient(to right, transparent, transparent);\n  background-position:\n    calc(100% - 22px) calc(1.05em + 4px),\n    calc(100% - 16px) calc(1.05em + 4px),\n    100% 0;\n  background-size: 6px 6px, 6px 6px, 2.5em 2.5em;\n  background-repeat: no-repeat;\n  padding-right: 48px;\n}\n\n.select-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n  gap: 16px;\n}\n\n.select-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  padding: 16px;\n  cursor: pointer;\n  background: #fff;\n  box-shadow: var(--shadow-light);\n  transition: var(--transition);\n  user-select: none;\n}\n\n.select-card:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-medium);\n}\n\n.select-card input {\n  width: 18px;\n  height: 18px;\n  accent-color: rgb(14, 114, 237);\n  margin: 0;\n}\n\n.select-card.active {\n  border-color: var(--primary-hover);\n  box-shadow: 0 0 0 3px hsla(var(--toggle-shadow), .12);\n}\n\n.select-card-label {\n  font-weight: 600;\n  color: #374151;\n}\n\n.section {\n  display: none;\n}\n\n.section.active {\n  display: block;\n}\n\n@media (max-width: 768px) {\n  .responsive-item {\n    padding: 20px;\n    border-radius: var(--border-radius);\n  }\n\n  .responsive-fields {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .btn-base {\n    min-width: 100px;\n    height: 40px;\n    font-size: 13px;\n    padding: 8px 16px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
